'use strict';

import template from './sign_up_form.html';

const EMAIL_EXISTS_ERROR = 'email-exists';
const controller = [
  'auth',
  'accountActivationModal',
  'config',

  function (auth, accountActivationModal, config) {
    this.data = {};

    grecaptcha.render('recaptcha-container', {
      'sitekey' : config.recaptcha.siteKey,
      callback: (token) => {
        this.data.token = token;
        this.signUpForm.token.$setValidity('valid', true);
        this.signUpForm.token.$setValidity('required', true);
      }
    });

    this.submit = function () {
      this.isLoading = true;

      auth.signUpWithEmail(this.data)
        .then(function () {
          accountActivationModal.open();
          this.done();
        }.bind(this))
        .catch(function (response) {
          var status = response.status;
          var error = response.data && response.data.error;
          this.data.token = '';
          
          if (status === 400 && error === EMAIL_EXISTS_ERROR) {
            this.signUpForm.email.$setValidity('unique', false);
          } else if (status === 400 && error === CAPTCHA_ERROR) {
            this.signUpForm.token.$setValidity('valid', false);
            grecaptcha.reset();
          }
        }.bind(this))
        .finally(function () {
          delete this.isLoading;
        }.bind(this));
    };
  }
];

function saSignUpForm () {
  return {
    template: template,
    replace: true,
    scope: {
      done: '&',
      data: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}

export default saSignUpForm;



// WEBPACK FOOTER //
// ./app/src/modules/join/sign_up_form.component.js